import { render, staticRenderFns } from "./DeliveryLogisticsRecord.vue?vue&type=template&id=7b0d5d88&scoped=true&"
import script from "./DeliveryLogisticsRecord.vue?vue&type=script&lang=js&"
export * from "./DeliveryLogisticsRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0d5d88",
  null
  
)

export default component.exports